<template>
  <div :class="['mb-3', error ? 'input-field text-danger' : 'input-field']">
    <label :for="id" class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>

    <VueDatePicker
        :id="id"
        :model-value="modelValue"
        :enable-time-picker="false"
        :month-picker="isMonthMode"
        :format="format"
        auto-apply
        @update:model-value="onUpdate"
    />

    <div v-if="error" class="invalid-feedback d-block">{{ error }}</div>
  </div>
</template>

<script setup>
import { v4 as uuidv4 } from 'uuid'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Date, Object],
    default: null
  },
  label: {
    type: String,
    default: ''
  },
  isMonthMode: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  format: {
    type: [String, Function],
    default: () => null
  },
  error: String
})

const emit = defineEmits(['update:modelValue'])
const id = computed(() => `date-${uuidv4()}`)

const onUpdate = (value) => {
  emit('update:modelValue', value)
}
</script>